export const isEmail = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
export const isMobile = /^(05)([0-9]{8})$/i;
